import { STORAGE_KEYS } from './storageKeys';

/**
 * A registry of logout callbacks. Any screen can call `registerLogoutHandler`
 * to subscribe. When a 401 is detected, all handlers are invoked.
 */
const logoutHandlers = new Set();

export const registerLogoutHandler = (fn) => {
  logoutHandlers.add(fn);
  return () => logoutHandlers.delete(fn); // returns unsubscribe function
};

const triggerLogout = () => {
  localStorage.clear();
  logoutHandlers.forEach((fn) => fn());
};

/**
 * Drop-in replacement for `fetch` that automatically handles 401 Unauthorized
 * responses by clearing local storage and triggering logout navigation.
 */
export const fetchWithAuth = async (url, options = {}) => {
  const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    triggerLogout();
    // Return a "dead" response so callers can still check `.ok` safely
    return new Response(null, { status: 401, statusText: 'Unauthorized' });
  }

  return response;
};
